webpackJsonp([50056870447050],{

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patientInfo = function patientInfo() {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h2',
	            null,
	            'Patient Information'
	        ),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/first-visit' },
	            'Your first visit and F.A.Q.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/patient-forms' },
	            'Patient Forms'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/fees' },
	            'Fees'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/cancelation-policy' },
	            'Cancelation Policy'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null)
	    );
	};
	
	exports.default = patientInfo;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-patient-information-js-a3660123e6e0685b994c.js